/*jslint node: true, browser: true*/
"use strict";

var ko = require("pli/knockout");

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// "ReportHistoryItem" view model
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

function ReportHistoryItemViewModel() {

    this.id = ko.observable();
    this.fileStoreId = ko.observable();
    this.fileName = ko.observable();
    this.fileCreatedBy = ko.observable();
    this.criteriaJson = ko.observable();

    this.extras = function ReportHistoryViewModelExtras() { return; };
    this.extras.criteria = ko.computed(ReportHistoryItemViewModel.prototype._parseCriteria, this);
}


//-------------------------------------------
ReportHistoryItemViewModel.prototype._parseCriteria = function parseCriteria() {
    if (!this.criteriaJson()) { return {}; }
    return JSON.parse(this.criteriaJson());
};


//-------------------------------------------
ReportHistoryItemViewModel.prototype.loadViewModel = function loadViewModel(record) {
    if (!record) { record = {}; }
    this.id(record.fileStoreId);
    this.fileStoreId(record.fileStoreId);
    this.fileName(record.fileName);
    this.criteriaJson(record.criteria);
    this.fileCreatedBy(record.fileCreatedBy);
};


//-------------------------------------------
ReportHistoryItemViewModel.prototype.itemComparer = null; // rely on server-side sorting (append-only on the client)


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = ReportHistoryItemViewModel;



//////////////////
// WEBPACK FOOTER
// ./app/report-rentalsexport/reportHistoryItemViewModel.js
// module id = 763
// module chunks = 49